import {
  Alert,
  Button,
  Icons,
  Input,
  Modal,
  Space,
  Typography,
} from "@pankod/refine-antd";

import {
  GENERATE_LOGIN_URL_LABEL,
  LOGIN_URL_BLOCKED_FOOTER,
  LOGIN_URL_BLOCKED_WARNING,
  LOGIN_URL_MODAL_DESCRIPTION,
  LOGIN_URL_MODAL_WARNING,
} from "../utils/login-url";

type GenerateLoginUrlModalProps = {
  visible: boolean;
  loading: boolean;
  budgetName?: string;
  controlNumber?: string | number | null;
  healthInsurerName?: string;
  contingencyUrl: string | null;
  onCancel: () => void;
  onConfirm: () => void;
  onRetryOpen: () => void;
  onCopy: () => void;
};

export const GenerateLoginUrlModal: React.FC<GenerateLoginUrlModalProps> = ({
  visible,
  loading,
  budgetName,
  controlNumber,
  healthInsurerName,
  contingencyUrl,
  onCancel,
  onConfirm,
  onRetryOpen,
  onCopy,
}) => {
  if (!visible) {
    return null;
  }

  return (
    <Modal
      visible={visible}
      title={GENERATE_LOGIN_URL_LABEL}
      footer={null}
      onCancel={loading ? undefined : onCancel}
      destroyOnClose
    >
      {contingencyUrl ? (
        <Space direction="vertical" size={16} style={{ width: "100%" }}>
          <Alert type="warning" message={LOGIN_URL_BLOCKED_WARNING} showIcon />

          <Space direction="vertical" size={4}>
            <span>
              <Typography.Text type="secondary">
                N° de Controle:{" "}
              </Typography.Text>
              <Typography.Text strong>{controlNumber}</Typography.Text>
            </span>
            <span>
              <Typography.Text type="secondary">Operadora: </Typography.Text>
              <Typography.Text strong>{healthInsurerName}</Typography.Text>
            </span>
          </Space>

          <Input.TextArea value={contingencyUrl} readOnly autoSize rows={2} />

          <Typography.Text type="secondary">
            {LOGIN_URL_BLOCKED_FOOTER}
          </Typography.Text>

          <Space
            size={12}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button onClick={onCancel}>Fechar</Button>
            <Button icon={<Icons.CopyOutlined />} onClick={onCopy}>
              Copiar URL
            </Button>
            <Button
              type="primary"
              icon={<Icons.LinkOutlined />}
              onClick={onRetryOpen}
            >
              Abrir Tela de Login
            </Button>
          </Space>
        </Space>
      ) : (
        <Space direction="vertical" size={16} style={{ width: "100%" }}>
          <Typography.Paragraph style={{ margin: 0 }}>
            {LOGIN_URL_MODAL_DESCRIPTION}
          </Typography.Paragraph>

          <Space direction="vertical" size={4}>
            <span>
              <Typography.Text type="secondary">Titular: </Typography.Text>
              <Typography.Text strong>{budgetName}</Typography.Text>
            </span>
            <span>
              <Typography.Text type="secondary">
                N° de Controle:{" "}
              </Typography.Text>
              <Typography.Text strong>{controlNumber}</Typography.Text>
            </span>
            <span>
              <Typography.Text type="secondary">Operadora: </Typography.Text>
              <Typography.Text strong>{healthInsurerName}</Typography.Text>
            </span>
          </Space>

          <Alert type="warning" message={LOGIN_URL_MODAL_WARNING} showIcon />

          <Space
            size={12}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button disabled={loading} onClick={onCancel}>
              Cancelar
            </Button>
            <Button
              type="primary"
              icon={!loading ? <Icons.LinkOutlined /> : undefined}
              loading={loading}
              disabled={loading}
              onClick={onConfirm}
            >
              {loading ? "Gerando…" : "Gerar e Abrir"}
            </Button>
          </Space>
        </Space>
      )}
    </Modal>
  );
};
